'use strict';

function MoneyUpDashboardHomeWealth() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_WealthController, _MoneyUpDashboardHomeBase];

  this.presenter = null;
  this.analytics = null;
  this.onComplete = function () {};

  this._disclaimers = {
    inactive: {
      text: 'disclaimer.mogoWealth'
    }
  };

  this.init = function () {
    this._super();
    this._connectionIssueConfig = this._getConnectionIssueConfig();
    $.when(this.presenter._contentLoadedPromise).then(this._setState.bind(this));
  };

  this.initAllReady = function () {
    this._super();
    this.initPage();
  };

  this.initPage = function () {
    var cellSettings = {
      product: 'MogoWealth',
      contentExtensions: this._content,
      disclaimers: this._disclaimers
    };

    this._createProductCell(cellSettings);
    this.onComplete(); // tell page component is loaded
  };

  this._setState = function () {
    if (!_this.node.querySelector('.js--dashboard-product').mogo().create) {
      _this._productCell = _this._getProductCell();
      var productState = 'loading';
      var analyticsState = 'Loading';

      productState = 'inactive';
      analyticsState = 'Inactive';

      _this._productCell.setState(productState, analyticsState);
      // no scenarios for when an alert occurs
      _this._setAlertState(analyticsState);
    }
  };

  this._setAlertState = function () {
    _this._productCell.showAlert(false);
  };

  // dynamic content construction
  this._getInactiveContentString = function () {
    return _this.presenter.getModelProperty('content.pages.MoneyUpDashboardHome.productTiles.wealthInactive.message');
  };

  // define after any methods that are referenced in definition
  this._content = {
    inactive: this._getInactiveContentString
  };

  this.destroy = function () {
    this._super();
  };
}